import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { generateHtmlAttrId, generateId } from '../utils/generate-base-entity'
import { CarouselItemInterface } from './carousel.schema'

export const createCarouselItem = (
  parentId: string,
  masterBlockId?: MasterBlockIdType,
  creationItemNumber = 1,
): CarouselItemInterface => {
  return {
    id: generateId(),
    type: EntityTypeEnum.CarouselItem,
    htmlAttrId: generateHtmlAttrId(EntityTypeEnum.CarouselItem),
    creationItemNumber,
    parentId,
    masterBlockId,
    childIds: [],
  }
}
